module.exports = __webpack_public_path__ + "img/chanpinbianji.6868b9f1.png";